import { ANIMATION_DURATION_IN_MILLIS } from "components/Message/configs";
import MessageForm from "components/Message/Form";
import { STREET_PRODUCT_ID } from "configs/demonstration";
import useResizeObserver from "hooks/useResizeObserver";
import MessageProvider from "providers/MessageProvider";
import React, { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { breakpoints } from "theme/breakpoints";
import Prompt from "./Prompt";
import {
  Container,
  FORM_NEGATIVE_OFFSET,
  FormWrapper,
  PromptContainer,
  StyledContentContainer,
  StyledMessageImage,
  Wrapper,
} from "./styles";

const Message: React.FC = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isFormSuccessVisible, setIsFormSuccessVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const promptRef = useRef<HTMLDivElement>(null);
  const promptContainerRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const onResizeHandler = useCallback(() => {
    if (isFormVisible || !containerRef.current || !promptContainerRef.current) {
      return;
    }

    containerRef.current.style.maxHeight = `${promptContainerRef.current.clientHeight}px`;
  }, [isFormVisible]);

  useResizeObserver(promptContainerRef, onResizeHandler);

  const onShowForm = () => {
    setIsFormVisible(true);

    if (
      !containerRef.current ||
      !promptContainerRef.current ||
      !formRef.current
    ) {
      return;
    }

    const formHeightOffset =
      window.innerWidth <= parseInt(breakpoints.md, 10)
        ? 0
        : FORM_NEGATIVE_OFFSET;

    const targetHeight =
      formRef.current.clientHeight +
      promptContainerRef.current.clientHeight +
      formHeightOffset;

    containerRef.current.style.maxHeight = `${targetHeight}px`;

    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.style.maxHeight = "none";
      }
    }, ANIMATION_DURATION_IN_MILLIS);
  };

  const onHideForm = () => {
    setIsFormVisible(false);

    if (!containerRef.current || !promptContainerRef.current) {
      return;
    }

    containerRef.current.style.maxHeight = `${containerRef.current.clientHeight}px`;
    containerRef.current.style.maxHeight = `${promptContainerRef.current.clientHeight}px`;
  };

  const onFormSuccess = () => {
    onHideForm();
    setIsFormSuccessVisible(true);
  };

  const onResetPrompt = () => setIsFormSuccessVisible(false);

  return (
    <MessageProvider
      isFormVisible={isFormVisible}
      isFormSuccessVisible={isFormSuccessVisible}
      onShowForm={onShowForm}
      onResetPrompt={onResetPrompt}
    >
      <Wrapper>
        <StyledContentContainer>
          <Container ref={containerRef}>
            <PromptContainer ref={promptContainerRef}>
              <StyledMessageImage
                role="img"
                aria-labelledby={
                  t("10713") /* Estacionamento pago através do parquímetro */
                }
                title={
                  t("10713") /* Estacionamento pago através do parquímetro */
                }
              />
              <Prompt ref={promptRef} />
            </PromptContainer>
            <FormWrapper ref={formRef}>
              <MessageForm
                onCancel={onHideForm}
                onSuccess={onFormSuccess}
                productId={STREET_PRODUCT_ID}
              />
            </FormWrapper>
          </Container>
        </StyledContentContainer>
      </Wrapper>
    </MessageProvider>
  );
};

export default Message;
